import React from 'react';
import './DashboardDataTable.css';

export type DashboardDataTableProps = {
  children: React.ReactNode;
  className?: string;
  /** Compact row padding */
  size?: 'sm' | 'md';
  /** Optional accessible name for the table */
  'aria-label'?: string;
};

/**
 * Standard dashboard data table shell — brand header, hover rows, shared spacing.
 * Pass `<thead>` / `<tbody>` (and optional `<tfoot>`) as children.
 */
const DashboardDataTable: React.FC<DashboardDataTableProps> = ({
  children,
  className = '',
  size = 'md',
  'aria-label': ariaLabel,
}) => {
  return (
    <div className={`table-responsive dashboard-data-table-wrap ${className}`.trim()}>
      <table
        className={[
          'table',
          'table-hover',
          'align-middle',
          'mb-0',
          'dashboard-data-table',
          size === 'sm' ? 'table-sm' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-label={ariaLabel}
      >
        {children}
      </table>
    </div>
  );
};

export default DashboardDataTable;
